export const splitPromptsByTarget = (list = []) => {
  const prompts = Array.isArray(list) ? list : [];
  return {
    directPrompts: prompts.filter((prompt) => (prompt?.target || "report") === "report"),
    promptOnPromptPrompts: prompts.filter((prompt) => (prompt?.target || "report") === "assistant"),
  };
};
